import React,{useEffect} from 'react'
import axios from 'axios';
import {FolderOpenOutlined,BackwardOutlined} from '@ant-design/icons';

import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Select
} from '@chakra-ui/react';

function Reports() {

  const [activeFolders, setActiveFolders] = React.useState([])
  const [activeFiles, setActiveFiles] = React.useState([])
  const [activeColumn, setActiveColumn] = React.useState('Organization Name')
  const [openFolder, setOpenFolder] = React.useState(false)
  const [loading, setLoading] = React.useState(false);
  const [init, setInit] = React.useState(false);


  const handleFetchOrgs = async () => {
    setInit(true);
    try{
      const response = await axios.get('https://rightofway.erc.uic.edu/wp-json/uploaded_files_route/v1/uploaded_files');
      if(Object.keys(response.data).length > 0){
          setActiveFolders(Object.values(response.data));
          setInit(false);
      }
    }
    catch(error){
      setInit(false);
      console.log(error);
    }

  }

  const handleFetchId = async (folderName) => {
    //console.log('fetch id',folderName)
    setLoading(true);
    if(folderName!== 'undefined'){
      try{
        const response = await axios.post(`https://rightofway.erc.uic.edu/wp-json/uploaded_files_route/v1/uploaded_files_id`,{
          "organization_name": String(folderName)
        });
        if(Object.keys(response.data).length > 0){
          setOpenFolder(true)
          //set active columns as File Name
          setActiveColumn('File Name')
          //set active files
          setActiveFiles(response.data)
          setLoading(false);
          //for each item in response.data
          //console.log('response fetch id', response.data)
        }
      }
      catch(error){
        setLoading(false);
        console.log(error);
      }
    }
  }

  React.useEffect(() => {
    handleFetchOrgs();
  }
  ,[])







  return (
    <>
      <div className='container-fluid'>
      <div className='mt-4'>
  <div className='d-flex flex-row'>
    <a
      href='https://console.firebase.google.com/u/0/project/monarch-annual-reporting-32c7d/storage/monarch-annual-reporting-32c7d.appspot.com/files'
      target='_blank'
      rel='noreferrer'
    >
      <Button
        colorScheme='blue'
        size='md'
        style={{
          cursor: 'pointer'
        }}
      >
        Link to Uploaded Files
      </Button>
    </a>
  </div>
</div>


        {/* section for uploaded files */}
        <div>
          {
            openFolder ? <div className='d-flex flex-row'>
            <Text
              fontSize={'md'}
              color={'gray.600'}
              style={{cursor: 'pointer',
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: 'blue'
              }}
              onClick={() => {
                setOpenFolder(false)
                setActiveColumn('Organization Name')
              }}
            >
              <BackwardOutlined style={{fontSize: '20px', marginRight: '10px'}}/>
              Back to Organizations
            </Text>
            </div>:null
          }
        </div>

        {
          loading ? <div className='mt-4 d-flex flex-row'>
              <div>
                <Text fontSize={'md'} color={'gray.600'}
                fontWeight={600}
                style={
                  {
                    color: 'black'
                  }
                }
                >Fetching Files
                </Text>
                <Spinner />
              </div>
            </div> : null
        }

        {
          init ? <div className='mt-4 d-flex flex-row'>
              <div>
                <Text fontSize={'md'} color={'gray.600'}
                fontWeight={600}
                style={
                  {
                    color: 'black'
                  }
                }
                >Fetching Organizations
                </Text>
                <Spinner />
              </div>
            </div> : null
        }



        <section className='mt-4'>
          <div>
              <table className='table table-bordered'>
                <thead>
                  <tr>
                    <th>{activeColumn}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    activeFolders && activeFolders.map((folder, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {
                              openFolder ? <div>
                                {
                                  activeFiles.map((file, index) => {
                                    return (
                                      <div key={index}>
                                        <FolderOpenOutlined style={{fontSize: '20px', marginRight: '10px'}}/>
                                        <a
                                          href={file.url}
                                          target='_blank'
                                          rel='noreferrer'
                                          >
                                          <Text fontSize={'md'} color={'gray.600'}
                                          style={{cursor: 'pointer',
                                          textDecoration: 'underline',
                                          fontWeight: 'bold',
                                          color: 'blue'
                                          }}
                                          >{file.name}</Text>
                                        </a>
                                      </div>
                                    )
                                  })
                                }
                              </div>:
                              <div>
                              <FolderOpenOutlined style={{fontSize: '20px', marginRight: '10px'}}/>
                              <Text fontSize={'md'} color={'gray.600'}
                              style={{cursor: 'pointer',
                              textDecoration: 'underline',
                              fontWeight: 'bold',
                              color: 'blue'
                              }}
                              onClick={() => {
                                handleFetchId(folder);
                              }}
                              >{folder}</Text>
                              </div>
                            }
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
          </div>
        </section>


      </div>
    </>
  )
}

export default Reports